export const formatStorageSize = (size: number): string => {
  if (size >= 1000) {
    return `${Math.floor(size / 1000)}TB`;
  }

  return `${size}GB`;
};
